var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.138 35.641c8.666 0 15.716-7.097 15.716-15.82 0-1.258-.147-2.482-.424-3.655A15.548 15.548 0 0029.138 8.5l-.016.016C26.287 5.724 22.409 4 18.138 4v7.765c2.163 0 4.13.87 5.571 2.278l-.004.005c3.152 3.087 3.189 8.18.081 11.353-3.107 3.174-8.2 3.244-11.353.157L7 31.106c3.085 3.021 7.115 4.502 11.138 4.458v.077z",
    fill: "currentColor"
  })));
}
export default SvgRefresher;